import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "@/contexts/AuthContext";

interface RequireAuthProps {
  children: ReactNode;
}

/**
 * Wraps protected routes. Waits for auth to load, then redirects
 * unauthenticated users to /auth with a `redirect` param so they
 * land back on the right page after signing in.
 */
export function RequireAuth({ children }: RequireAuthProps) {
  const { user, loading } = useAuthContext();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-muted-foreground">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to={`/auth?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  return <>{children}</>;
}
